<template>
    <SortPanel :show="true" />
</template>

<script lang="ts" setup>
    import SortPanel from '../SortPanel.vue';
</script>

